/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsUserMachineLicenseAssignmentItem,
    MelcoModelsUserMachineLicenseAssignmentItemFromJSON,
    MelcoModelsUserMachineLicenseAssignmentItemFromJSONTyped,
    MelcoModelsUserMachineLicenseAssignmentItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsUserMachineLicenseAssignment
 */
export interface MelcoModelsUserMachineLicenseAssignment {
    /**
     * 
     * @type {Array<MelcoModelsUserMachineLicenseAssignmentItem>}
     * @memberof MelcoModelsUserMachineLicenseAssignment
     */
    expiring_list?: Array<MelcoModelsUserMachineLicenseAssignmentItem> | null;
    /**
     * 
     * @type {Array<MelcoModelsUserMachineLicenseAssignmentItem>}
     * @memberof MelcoModelsUserMachineLicenseAssignment
     */
    assigned_list?: Array<MelcoModelsUserMachineLicenseAssignmentItem> | null;
    /**
     * 
     * @type {Array<MelcoModelsUserMachineLicenseAssignmentItem>}
     * @memberof MelcoModelsUserMachineLicenseAssignment
     */
    available_list?: Array<MelcoModelsUserMachineLicenseAssignmentItem> | null;
}

export function MelcoModelsUserMachineLicenseAssignmentFromJSON(json: any): MelcoModelsUserMachineLicenseAssignment {
    return MelcoModelsUserMachineLicenseAssignmentFromJSONTyped(json, false);
}

export function MelcoModelsUserMachineLicenseAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserMachineLicenseAssignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'expiring_list': !exists(json, 'expiring_list') ? undefined : (json['expiring_list'] === null ? null : (json['expiring_list'] as Array<any>).map(MelcoModelsUserMachineLicenseAssignmentItemFromJSON)),
        'assigned_list': !exists(json, 'assigned_list') ? undefined : (json['assigned_list'] === null ? null : (json['assigned_list'] as Array<any>).map(MelcoModelsUserMachineLicenseAssignmentItemFromJSON)),
        'available_list': !exists(json, 'available_list') ? undefined : (json['available_list'] === null ? null : (json['available_list'] as Array<any>).map(MelcoModelsUserMachineLicenseAssignmentItemFromJSON)),
    };
}

export function MelcoModelsUserMachineLicenseAssignmentToJSON(value?: MelcoModelsUserMachineLicenseAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'expiring_list': value.expiring_list === undefined ? undefined : (value.expiring_list === null ? null : (value.expiring_list as Array<any>).map(MelcoModelsUserMachineLicenseAssignmentItemToJSON)),
        'assigned_list': value.assigned_list === undefined ? undefined : (value.assigned_list === null ? null : (value.assigned_list as Array<any>).map(MelcoModelsUserMachineLicenseAssignmentItemToJSON)),
        'available_list': value.available_list === undefined ? undefined : (value.available_list === null ? null : (value.available_list as Array<any>).map(MelcoModelsUserMachineLicenseAssignmentItemToJSON)),
    };
}


